import {
    SHARE_WISHLIST_POPUP_ID as SOURCE_SHARE_WISHLIST_POPUP_ID,
} from 'SourceComponent/ShareWishlistPopup/ShareWishlistPopup.config';

export const SHARE_WISHLIST_POPUP_ID = SOURCE_SHARE_WISHLIST_POPUP_ID;
